import { render, staticRenderFns } from "./BootstrapBox.vue?vue&type=template&id=73ebeb90&scoped=true&"
import script from "./BootstrapBox.vue?vue&type=script&lang=js&"
export * from "./BootstrapBox.vue?vue&type=script&lang=js&"
import style0 from "./Styles/bootstrap-box.scss?vue&type=style&index=0&id=73ebeb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ebeb90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ebeb90')) {
      api.createRecord('73ebeb90', component.options)
    } else {
      api.reload('73ebeb90', component.options)
    }
    module.hot.accept("./BootstrapBox.vue?vue&type=template&id=73ebeb90&scoped=true&", function () {
      api.rerender('73ebeb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/BootstrapBox.vue"
export default component.exports